import CartTitleView from "../view/title.js";
import CartSectionView from "../view/section.js";

import CartSectionsModel from "../model/cart-sections.js";

import Animation from "../../animation/animation.js";
import ScrollToElement from "../../scroll-to-element/scroll-to-element.js";

import {
  removeElement
} from "../../render/render.js";

import {
  ActionType,
  defaultCartSectionsModelData
} from "../const.js";

import {
  EMPTY_CART_TEXT
} from "../lexicon.js";

export default class CartSections {
  constructor(titleSection, cartSections) {
    this._titleSection = titleSection;
    this._cartSections = cartSections;

    this._animation = new Animation();
    this._scrollToElement = new ScrollToElement();

    this._titleView = null;
    this._sectionsViews = [];

    this._model = null;

    this._handleChangeData = this._handleChangeData.bind(this);
    this._handleCartDataChange = this._handleCartDataChange.bind(this);
  }

  init() {
    this._titleView = new CartTitleView(this._titleSection);

    Array.from(this._cartSections)
      .forEach((section) => {
        this._sectionsViews.push(new CartSectionView(section));
      });

    this._model = new CartSectionsModel(Object.assign(
        {},
        defaultCartSectionsModelData
    ));
    this._model.addObserver(this._handleChangeData);

    if (window.CartData) {
      window.CartData.addObserver(this._handleCartDataChange);
    }
  }

  _setEmptyCart() {
    const sectionsViewsCount = this._sectionsViews.length;

    this._sectionsViews.forEach((view, index) => {
      this._animation.slideUp(
          view.getElement(),
          null,
          null,
          () => {
            removeElement(view.getElement());
            this._sectionsViews.splice(index);


            if (sectionsViewsCount === index + 1) {
              this._model.changeData(Object.assign(
                  {},
                  this._model.getData(),
                  {
                    scrolledToTitle: true
                  }
              ), ActionType.SCROLL_TO_TITLE);
            }
          }
      );
    });

    this._titleView.setHeadingText(EMPTY_CART_TEXT);
  }

  _handleChangeData(action) {
    switch (action) {
      case ActionType.SCROLL_TO_TITLE:
        this._scrollToElement.scroll({
          element: this._titleView.getElement()
        });
        break;
    }
  }

  _handleCartDataChange(action) {
    switch (action) {
      case ActionType.CLEAR:
        this._setEmptyCart();
        break;
    }
  }
}
